import styled, { css } from 'styled-components'
import { Search } from 'semantic-ui-react'

import { ReactComponent as SearchIconBla } from '@/assets/images/icons/general/search-md.svg'
import Button from '@/ui/Button'
import Icon from '@/ui/Icon'
import { IconContainerProps, StyledInputProps } from './types'

export const StyledButton = styled(Button).attrs({
  leftIcon: <SearchIconBla />,
})`
  ${({ theme }) => css`
    &&& {
      height: 37px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: none !important;
      border-color: ${theme.primaryColor} !important;
      margin-right: 0.25em;

      ${theme.mediaQueries.mobile} {
        margin: 0;
      }
    }
  `}
`

const StyledInputInner = styled(
  ({ hideSearchButton, ...rest }: StyledInputProps) => <Search {...rest} />,
)<StyledInputProps>`
  ${({ theme, hideSearchButton }) => css`
    &&& {
      min-width: 300px;
      max-width: 300px;

      .input {
        width: 100%;
      }

      input {
        color: ${theme.primaryFontColor} !important;
        height: 37px;

        ${!hideSearchButton &&
        css`
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
          border-right: none !important;
        `}
        ${hideSearchButton &&
        css`
          padding-left: 35px;
        `}
      }

      .search.icon {
        display: none;
      }

      ${theme.mediaQueries.mobile} {
        width: 100%;
        max-width: 100%;
        min-width: 0;
      }
    }
  `}
`

export const StyledInput: React.FC<StyledInputProps> = props => (
  <StyledInputInner {...props} />
)

export const IconContainer = styled.div<IconContainerProps>`
  position: absolute;
  right: ${({ hideSearchButton }) => (hideSearchButton ? 0 : '63px')};
`
export const SearchIcon = styled(Icon)`
  &&&& {
    position: absolute;
    left: 10px;
    top: 48%;
    color: #abafa9;
    z-index: 2;
    transform: translateY(-50%);
  }
`

export const StyledIcon = styled(Icon)`
  &&& {
    position: relative;
    top: 10px;
    cursor: pointer;
  }
`
